import React from "react";
import {analyticsColorScheme, scoreColors} from "../color-scheme";

const phaseColSpan = (reportAnalytics, phase, enablePtoAnalytics) => {
  let weeks = reportAnalytics.weeks[phase.guid];
  return weeks.reduce((acc, week) => acc + weekColSpan(reportAnalytics, phase, week, enablePtoAnalytics), (enablePtoAnalytics? 0: 1))
}

const weekColSpan = (reportAnalytics, phase, week, enablePtoAnalytics) => {
  return week.days.reduce((acc, day) => {
    let reportsByDay = dayColSpan(reportAnalytics, phase, week, day, enablePtoAnalytics)
    return acc + reportsByDay
  }, (enablePtoAnalytics? 0: 1))
}

const dayColSpan = (reportAnalytics, phase, week, day, enablePtoAnalytics) => {
  return reportAnalytics.reportMap[`${phase.guid}${week.weekNumber}${day}`]? reportAnalytics.reportMap[`${phase.guid}${week.weekNumber}${day}`].length: (enablePtoAnalytics?0 :1)
}

const getDayMonthFromDate = (date) => {
  return date.substring(0, 5)
}

const getSequenceNumber = (reports) => {
  if (reports && reports.length) {
    return `#${reports[0].sequence}`
  }
  return ' '
}

const getEvaluationValue = (evaluation) => {
  if (!evaluation) {
    return 'N/R'
  }
  if (evaluation.rating === 'acceptable') {
    return <span className="fa fa-check"/>;
  } else if (evaluation.rating === 'unAcceptable') {
    return <span className="fa fa-minus"/>;
  } else if (evaluation.rating) {
    return evaluation.ratingLabel || evaluation.rating;
  } else if (evaluation.notObserved) {
    return <span>N.O.</span>
  } else if (evaluation.notResponsive) {
    return <span>N.R.T</span>
  }
  return 'N/R'
}

const getEvaluationTextValue = (evaluation) => {
  if (!evaluation) {
    return 'N/R'
  }
  if (evaluation.rating === 'acceptable') {
    return 'Acceptable'
  } else if (evaluation.rating === 'unAcceptable') {
    return 'Unacceptable'
  } else if (evaluation.rating) {
    return evaluation.ratingLabel || evaluation.rating;
  } else if (evaluation.notObserved) {
    return 'N.O.'
  } else if (evaluation.notResponsive) {
    return 'N.R.T'
  }
  return 'N/R'
}

const getEvaluationComments = (question) => {
  if (!question || !question.isEvaluationRating) {
    return []
  }

  return [
    question.traineeEvaluation && question.traineeEvaluation.comment ? {
      label: 'Trainee comment',
      comment: question.traineeEvaluation.comment
    } : null,
    question.trainerEvaluation && question.trainerEvaluation.comment ? {
      label: 'Trainer comment',
      comment: question.trainerEvaluation.comment
    } : null
  ].filter(Boolean)
}

const hasCellComments = (question) => {
  if (!question) {
    return false
  }
  if (question.isEvaluationRating) {
    return !!getEvaluationComments(question).length
  }
  return !!(question.comment || question.observationComment)
}

const getEvaluationCellValue = (question, forExport = false) => {
  if (forExport) {
    return `Trainee: ${getEvaluationTextValue(question.traineeEvaluation)}\nTrainer: ${getEvaluationTextValue(question.trainerEvaluation)}`
  }

  return (
    <div className="evaluation-analytics-cell">
      <div className="evaluation-analytics-line">
        <span className="evaluation-analytics-label">T</span>
        <span>{getEvaluationValue(question.traineeEvaluation)}</span>
      </div>
      <div className="evaluation-analytics-line evaluation-analytics-trainer">
        <span className="evaluation-analytics-label">TR</span>
        <span>{getEvaluationValue(question.trainerEvaluation)}</span>
      </div>
    </div>
  )
}

const getCellValue = (reportType, question) => {
  if(!question) {
    return <span></span>
  }
  if (reportType === 'time-spend') {
    if (question.timeSpend) {
      return this.timeConvert(question.timeSpend);
    } else {
      return <span>0</span>
    }
  }

  if (question.isEvaluationRating) {
    return getEvaluationCellValue(question)
  }

  if (question.rating === 'acceptable') {
    return <span className="fa fa-check"/>;
  } else if (question.rating === 'unAcceptable') {
    return <span className="fa fa-minus"/>;
  } else if (question.rating) {
    return question.ratingLabel || question.rating;
  } else if (question.notObserved) {
    return <span>N.O.</span>
  } else {
    return <span>N.R.T</span>
  }
}


const getAvgCellValue = (reportType, avgField) => {
  if (reportType === 'time-spend') {
    return this.timeConvert(avgField.timeSpendAvg)
  } else {
    return avgField ? avgField.avgRating: 'N/R'
  }
}


const getBackgroundColor = (reportType, question, scale) => {

  if(!question) {
    return null
  }
  if(question.ratingLabel && !question.isEvaluationRating) {
    return scoreColors[question.rating]
  }
  if (question.rating && reportType === 'rating') {
    return analyticsColorScheme[question.scale || scale || 5][question.rating];
  } else {
    return null
  }
}

const getCellColor = (reportType, question) => {
  if (reportType === 'rating') {
    return question && question.rating ? '#fff' : '#000'
  }
  return '#000'
}

function getWeeks(weeks, phase, reportAnalyticsObj, enablePtoAnalytics) {
  if(enablePtoAnalytics) {
    return weeks.filter(week => !!week.days.find(day => !!reportAnalyticsObj.reportMap[`${phase.guid}${week.weekNumber}${day}`]))
  }
  return weeks
}

function getDays(days, phase, week, reportAnalyticsObj, enablePtoAnalytics) {
  if(enablePtoAnalytics) {
    return days.filter(day => !!reportAnalyticsObj.reportMap[`${phase.guid}${week.weekNumber}${day}`])
  }

  return days
}


export {
  phaseColSpan,
  weekColSpan,
  dayColSpan,
  getDayMonthFromDate,
  getSequenceNumber,
  getCellValue,
  getAvgCellValue,
  getBackgroundColor,
  getCellColor,
  getEvaluationCellValue,
  getEvaluationComments,
  hasCellComments,
  getWeeks,
  getDays
}
